export const notifyConstants = {
  PUSH_NOTIFICATION: '[Ui] Push notification',
  REMOVE_NOTIFICATION: '[Ui] Remove notification'
}
